import Alert from "@mui/material/Alert";
import { useSnackbar } from "notistack";
// External library import
import queryString from "query-string";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { sendActionToAdobeAnalytics } from "../../common/analytics/adobeanalytics/adobeanalytics";
import {
  appConstants,
  ENVIRONMENT,
  SNACKBAR_TYPE,
} from "../../common/constants/constants";
import { getTokenId } from "../../common/services/authService";
import { checkadmin } from "../../common/services/herdAccess.service";
import NetworkService from "../../common/services/networkService";
//constant,service,utility import
import { getEnvironment } from "../../common/utils";

const ExternalLoginScreen = (props) => {
  const history = useHistory();
  const [errorMsg, setErrorMsg] = React.useState("");
  const { enqueueSnackbar } = useSnackbar();

  const EnvFlag = getEnvironment();
  let logoENV = "";
  if (EnvFlag === ENVIRONMENT.PROD) {
    logoENV = "";
  } else if (EnvFlag === ENVIRONMENT.QA) {
    logoENV = "-qa";
  } else if (EnvFlag === ENVIRONMENT.DEV) {
    logoENV = "-dev";
  } else {
    logoENV = "-local";
  }

  useEffect(() => {
    let code = getAuthCode(props);
    if (code) {
      enqueueSnackbar("Logging in, please wait...", {
        anchorOrigin: { vertical: "top", horizontal: "center" },
        variant: SNACKBAR_TYPE.DEFAULT,
      });

      getTokenId(code, appConstants.External).then(
        (response) => {
          NetworkService.setAccessTokenAuthHeader(response);
          localStorage.setItem(
            appConstants.LoginSessionKey,
            JSON.stringify(response),
          );
          checkadmin().then((response) => {
            let jwt = JSON.parse(
              atob(
                JSON.parse(
                  localStorage.getItem("LoginSessionKey"),
                ).access_token.split(".")[1],
              ),
            );
            if (["Administrator", "User"].includes(response)) {
              sendActionToAdobeAnalytics("login", {
                user: { userId: jwt.userid, userType: response },
              });
              localStorage.setItem(
                appConstants.UserInfo,
                JSON.stringify({
                  userId: jwt.mail,
                  userType: appConstants.External,
                }),
              );
              enqueueSnackbar("Login Successfully!!", {
                anchorOrigin: { vertical: "top", horizontal: "center" },
                variant: SNACKBAR_TYPE.SUCCESS,
              });
              history.push("/dashboard/herds");
            } else {
              enqueueSnackbar(
                "You are not an authorized user of this system.  Please request access.",
                {
                  anchorOrigin: { vertical: "top", horizontal: "center" },
                  persist: true,
                  variant: SNACKBAR_TYPE.ERROR,
                },
              );
              localStorage.clear();
              localStorage.setItem("businessLinkId", jwt.userid);
              history.push("/login");
            }
          });
        },
        (error) => {
          setErrorMsg(
            "Error: " +
              error.response.data.error +
              "\n Error Description: " +
              error.response.data.error_description +
              "\n Status Code: " +
              error.response.status,
          );
        },
      );
    }
  }, [history, props, enqueueSnackbar]);
  // Remove auth code from browser history after successful login
  window.history.replaceState({}, document.title, "/");

  /**
   * Method will return auth code coming from server.
   * @param {*} props
   */
  function getAuthCode(props) {
    if (props) {
      let params = queryString.parse(props.location.search);

      // Validate state parameter for CSRF protection
      const returnedState = params.state;
      const storedState = sessionStorage.getItem("oauth_state");

      if (returnedState && storedState && returnedState === storedState) {
        // State is valid, clean up
        sessionStorage.removeItem("oauth_state");
        return params.code;
      } else if (!returnedState) {
        // No state in callback (might be old flow or error)
        console.warn("No state parameter in OAuth callback");
        return params.code;
      } else {
        // State mismatch - possible CSRF attack
        console.error("OAuth state mismatch - possible CSRF attack");
        return null;
      }
    }
  }

  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-form">
          <i className={"ag-icon logo ag-icon-benchmark-logo" + logoENV}></i>
          {errorMsg && (
            <Alert className="alert-error" severity="warning">
              {errorMsg}
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExternalLoginScreen;
